import styled from "@emotion/styled";
import Link from "@mui/material/Link";

export const MuiLink = styled(Link)({
	alignItems: "center",
	display: "flex"
}) as typeof Link;
